<div class="search-toggle">
  @if (!isDTD) {
    <div class="search-toggle-wrapper">
      <div class="search-toggle__text">
        @if (!toggleState) {
          <div id="search-summary">
            @switch (serviceType) {
              @case (ServiceType.Flight) {
                @if (!searchArgs?.multiDestination?.length) {
                  {{
                    searchArgs.originAirportFull
                      ? searchArgs.originAirportFull + ' (' + searchArgs.originAirport + ')'
                      : (searchArgs.originAirport | airportIata | async)
                  }}
                  -
                  {{
                    searchArgs.destinationAirportFull
                      ? searchArgs.destinationAirportFull +
                        ' (' +
                        searchArgs.destinationAirport +
                        ')'
                      : (searchArgs.destinationAirport | airportIata | async)
                  }}:
                  {{ searchArgs.outboundDate | sabsDate: 1 }}
                  {{ searchArgs.returnDate ? ' - ' + (searchArgs.returnDate | sabsDate: 1) : '' }}
                }
                @if (searchArgs?.multiDestination?.length) {
                  @for (multiDestination of searchArgs?.multiDestination; track multiDestination) {
                    <div>
                      {{ multiDestination.orig | airportIata | async }} -
                      {{ multiDestination.dest | airportIata | async }}:
                      {{ multiDestination.date | sabsDate: 1 }}
                    </div>
                  }
                }
              }
              @case (ServiceType.Rail) {
                @if (!searchArgs.isAirportExpress) {
                  {{ searchArgs.travellingFrom?.name }},
                  @if (
                    searchArgs.travellingFrom?.stationCode ||
                    searchArgs.travellingFrom?.railstation?.stationCode
                  ) {
                    ({{
                      searchArgs.travellingFrom?.stationCode ||
                        searchArgs.travellingFrom?.railstation?.stationCode
                    }}),
                  }
                  {{
                    searchArgs.travellingFrom?.locationDetails?.country ||
                      searchArgs.travellingFrom?.railstation?.locationDetails?.country
                  }}
                  - {{ searchArgs.travellingTo?.name }},
                  @if (
                    searchArgs.travellingTo?.stationCode ||
                    searchArgs.travellingTo?.railstation?.stationCode
                  ) {
                    ({{
                      searchArgs.travellingTo?.stationCode ||
                        searchArgs.travellingTo?.railstation?.stationCode
                    }}),
                  }
                  {{
                    searchArgs.travellingTo?.locationDetails?.country ||
                      searchArgs.travellingTo?.railstation.locationDetails?.country
                  }}
                }
                @if (searchArgs.isAirportExpress) {
                  {{ searchArgs.airportExpressStation | airportExpress }}
                }
                {{
                  searchArgs.outboundDepartureDateTime
                    ? (searchArgs.outboundDepartureDateTime | sabsDate: 1)
                    : (searchArgs.outboundArrivalDateTime | sabsDate: 1)
                }}
                <!-- if return jorney  -->
                {{
                  searchArgs.returnDepartureDateTime
                    ? ' - ' + (searchArgs.returnDepartureDateTime | sabsDate: 1)
                    : ''
                }}
                {{
                  searchArgs.returnArrivalDateTime
                    ? ' - ' + (searchArgs.returnArrivalDateTime | sabsDate: 1)
                    : ''
                }}
              }
              @case (ServiceType.InternationalRail) {
                {{ searchArgs.travellingFrom?.railstation?.name }} -
                {{ searchArgs.travellingTo?.railstation?.name }}
                {{ searchArgs.outboundDepartureDateTime | sabsDate: 1 }}
                <!-- if return jorney  -->
                @if (searchArgs.journeyType === irlJourneyType.ReturnJourney) {
                  {{ ' - ' + (searchArgs.returnDepartureDateTime | sabsDate: 1) }}
                }
              }
              @case (ServiceType.Eurostar) {
                @if (searchArgs.originAirport && searchArgs.destinationAirport) {
                  {{ searchArgs.originAirport | airportIata | async }} -
                  {{ searchArgs.destinationAirport | airportIata | async }}
                  {{ searchArgs.outboundDate | sabsDate: 1 }}
                  @if (searchArgs.returnDate) {
                    - {{ searchArgs.returnDate | sabsDate: 1 }}
                  }
                }
              }
              @case (ServiceType.Hotel) {
                @if (searchArgs.iata) {
                  {{ searchArgs.iata | airportIata | async }}:
                } @else if (searchArgs.hotelName) {
                  {{ searchArgs.hotelName }}:
                } @else if (searchArgs.cityName) {
                  {{ searchArgs.cityName }}:
                } @else if (searchArgs.officeId) {
                  {{ officeName }}:
                } @else if (searchArgs.trainStationCode) {
                  {{ searchArgs.trainStationCode | railStationNameByCode | async }}
                  Rail Station:
                } @else if (
                  searchArgs.countryCode && !searchArgs.cityName && !searchArgs.officeId
                ) {
                  Shortlist {{ searchArgs.countryCode }}
                } @else {
                  {{ searchArgs.postOrZipCode }}:
                }
                {{ searchArgs.startDate | sabsDate: 3 }} - {{ searchArgs.endDate | sabsDate: 3 }}
              }
              @case (ServiceType.Car) {
                @if (searchArgs.city) {
                  {{ searchArgs.city.pickupName }} {{ searchArgs.city.pickupAddressLines }} ({{
                    searchArgs.city.pickupCountryCode
                  }}) - {{ searchArgs.city.dropOffName }}
                  {{ searchArgs.city.dropOffAddressLines }} ({{
                    searchArgs.city.dropoffCountryCode
                  }}):
                }
                @if (searchArgs.airport) {
                  {{
                    searchArgs?.airport.pickupAirportFullName
                      ? searchArgs?.airport.pickupAirportFullName +
                        ' (' +
                        searchArgs?.airport.pickupCode +
                        ')'
                      : (searchArgs?.airport.pickupCode | airportIata | async)
                  }}
                  -
                  {{
                    searchArgs?.airport.dropoffAirportFullName
                      ? searchArgs?.airport.dropoffAirportFullName +
                        ' (' +
                        searchArgs?.airport.dropoffCode +
                        ')'
                      : (searchArgs?.airport.dropoffCode | airportIata | async)
                  }}:
                }
                @if (searchArgs.depot && searchArgs.depot.pickupVendor) {
                  {{ searchArgs.depot.pickupVendor }}
                  {{ searchArgs.depot.pickupAddressLines }}, {{ searchArgs.depot.pickupCityName }} -
                  {{ searchArgs.depot.dropoffVendor }}
                  {{ searchArgs.depot.dropoffAddressLines }},
                  {{ searchArgs.depot.dropoffCityName }}:
                }
                {{ searchArgs.pickupDateTime | sabsDate: 1 }} -
                {{ searchArgs.dropoffDateTime | sabsDate: 1 }}
              }
              @case (ServiceType.FastTrack) {
                @if (searchArgs) {
                  <span>
                    {{ searchArgs.locationCode | airportIata | async }}
                    {{ searchArgs.arrivalDatetime | sabsDate: 1 }}
                  </span>
                }
              }
              @case (ServiceType.Lounge) {
                <span>
                  {{ searchArgs.locationCode | airportIata | async }}:
                  {{ searchArgs.arrivalDatetime | sabsDate: 1 }}
                </span>
              }
              @case (ServiceType.Parking) {
                {{ searchArgs.locationCode | airportIata | async }}:
                {{ searchArgs.arrivalDatetime | sabsDate: 1 }} -
                {{ searchArgs.departDatetime | sabsDate: 1 }}
              }
              @case (ServiceType.Cab) {
                @if (searchArgs?.fromLocation; as fromLocation) {
                  @if (fromLocation.buildingName || fromLocation.streetAndNumber) {
                    {{ fromLocation.buildingName }} {{ fromLocation.streetAndNumber }},
                  }
                  {{ fromLocation.town }}
                  {{ fromLocation.countryCode }}
                  @if (!fromLocation.buildingName && !fromLocation.streetAndNumber) {
                    {{ fromLocation.postcode }},
                  }
                  -
                }
                @if (searchArgs?.toLocation; as toLocation) {
                  @if (toLocation.buildingName || toLocation.streetAndNumber) {
                    {{ toLocation.buildingName }} {{ toLocation.streetAndNumber }},
                  }
                  {{ toLocation.town }}
                  {{ toLocation.countryCode }}
                  @if (!toLocation.buildingName && !toLocation.streetAndNumber) {
                    {{ toLocation.postcode }},
                  }
                  :
                }
                {{ searchArgs.departs | sabsDate: 1 }}
              }
              @default {}
            }
          </div>
        }
      </div>
      <button
        href="javascript:void(0)"
        (click)="toggle()"
        appButton="small"
        class="change-btn"
        [attr.aria-expanded]="!!toggleState"
      >
        @if (toggleState) {
          <span i18n="@@searchToggleState_hide" id="hideSearch">Hide</span>
        }
        @if (!toggleState) {
          <span i18n="@@searchToggleState_change" id="changeSearch">Change</span>
        }
        <span i18n="@@searchToggleSearchOptions" class="visuallyhidden">search options</span>
      </button>
    </div>
  }
  @if (isDTD) {
    <a
      href="javascript:void(0)"
      (click)="toggle()"
      class="pb-3"
      [attr.aria-label]="toggleState ? 'Hide ' + text : 'Show ' + text"
    >
      <span>
        @if (toggleState) {
          <span i18n="@@searchToggleState_hide">Hide</span>
        }
        @if (!toggleState) {
          <span i18n="@@searchToggleState_show">Show</span>
        }
        {{ text | translate }}
      </span>
      <i [ngClass]="toggleState ? 'ico-tri-up' : 'ico-tri-down'" aria-hidden="true"></i>
    </a>
  }
</div>
@if (toggleState) {
  <ng-content></ng-content>
}
